<div *ngIf="isDiv" [title]="title" #withTooltip><ng-content></ng-content></div>
<span *ngIf="!isDiv" [title]="title" #withTooltip><ng-content></ng-content></span>